/* eslint-disable @typescript-eslint/no-explicit-any */
import MainTable from "../../Components/GenericComponents/MainTable";
import styles from "../../Styles/dashboard.module.css";
import { urlEnum } from "../../Utils/UrlEnum";
import { styleForTableWithTabs } from "../Users";

type OtherReportProps = {
  header: any[];
};
export function OtherReport(props: OtherReportProps) {
  const { header } = props;
  return (
    <div className={styles.mainContainerUser}>
      <MainTable
        urlEnumApi={urlEnum.otherReports}
        header={header}
        tableTitle={""}
        hideOptionButtons={{
          add: true,
          edit: { condition: (item: any) => true },
          delete: { condition: (item: any) => true },
        }}
        customStyle={{
          tableStyle: styleForTableWithTabs,
        }}
        tableCustomOptions={{
          showSearch: false,
        }}
      />
    </div>
  );
}
